module.exports = __webpack_public_path__ + "static/media/saxophone.1afeb5e7.svg";